import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { groupSelectors } from 'redux/group';
import { postSelectors } from 'redux/post';


const groupMatch = /^#?\/groups\/(?<id>\d+)\/?$/;
const newsfeedMatch = /^#?\/messages\/(?<id>\d+)\/?$/;
const postMatch = /^#?\/post\/(?<id>\d+)\/?$/;

const useSmartPostCreateInitialValues = () => {

  const { pathname } = useLocation();

  const channelId = useSelector(state => {
    const newsfeedId = pathname.match(newsfeedMatch)?.groups?.id;
    if (newsfeedId) {
      return newsfeedId;
    }

    const groupId = pathname.match(groupMatch)?.groups?.id;
    if (groupId) {
      return groupSelectors.getGroup(state, groupId)?.channelId;
    }

    const postId = pathname.match(postMatch)?.groups?.id;
    if (postId) {
      return postSelectors.getPost(state, postId)?.channel;
    }

    return null;
  });

  return channelId
    ? { channelId: +channelId }
    : {};
};

export default useSmartPostCreateInitialValues;
